import { FormControlLabel, FormControlLabelProps, Radio as MUIRadio, RadioProps as MUIRadioProps } from '@mui/material';
import styles from './Radio.module.scss';

type RadioProps = {
  formControlLabelProps?: Omit<FormControlLabelProps, 'control'> & Partial<FormControlLabelProps['control']>;
} & MUIRadioProps;

const PureRadio = (radioProps: MUIRadioProps) => (
  <MUIRadio
    icon={<div className={styles.icon} />}
    checkedIcon={<div className={styles.checkedIcon} />}
    {...radioProps}
  />
);

const Radio = ({ formControlLabelProps, ...rest }: RadioProps) => {
  if (formControlLabelProps) {
    return (
      <FormControlLabel
        {...formControlLabelProps}
        control={<PureRadio {...rest} />}
        classes={{ label: styles.label, root: styles.root }}
      />
    );
  }

  return <PureRadio {...rest} />;
};

export default Radio;
